export default __webpack_public_path__ + "static/media/down_button.57fef515.svg";